"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccentColors = exports.CoreColors = exports.ColorSetLookup = exports.OurBrands = exports.SigmaAldrichColors = exports.MerckMilliporeColors = void 0;
// Definitions for colors specific to the Merck Millipore domain
var MerckMilliporeColors;
(function (MerckMilliporeColors) {
    MerckMilliporeColors["BrandDark"] = "#002E74";
    MerckMilliporeColors["BrandLight"] = "#65ADE4";
    MerckMilliporeColors["BrandMain"] = "#0F69AF";
})(MerckMilliporeColors || (exports.MerckMilliporeColors = MerckMilliporeColors = {}));
// Definitions for colors specific to the Sigma-Aldrich domain.
var SigmaAldrichColors;
(function (SigmaAldrichColors) {
    SigmaAldrichColors["BrandDark"] = "#210953";
    SigmaAldrichColors["BrandLight"] = "#8264C3";
    SigmaAldrichColors["BrandMain"] = "#503191";
})(SigmaAldrichColors || (exports.SigmaAldrichColors = SigmaAldrichColors = {}));
/*
  Brand Specific Color Lookup Functionality:
  - Enum: Ensures the brand or color palette name exists when selecting a theme.
  - Object: Maps enum values to their corresponding color sets, allowing dynamic access and spread operation to load colors into usable Javascript objects.
*/
var OurBrands;
(function (OurBrands) {
    OurBrands["SigmaAldrich"] = "SigmaAldrichColors";
    OurBrands["MerckMillipore"] = "MerckMilliporeColors";
})(OurBrands || (exports.OurBrands = OurBrands = {}));
exports.ColorSetLookup = {
    MerckMilliporeColors,
    SigmaAldrichColors,
};
var CoreColors;
(function (CoreColors) {
    CoreColors["TextPrimary"] = "#000000";
    CoreColors["PrimaryMain"] = "#0F69AF";
    CoreColors["SecondaryText"] = "#ffffff";
    CoreColors["SecondaryDark"] = "#210953";
    CoreColors["SecondaryLight"] = "#8264C3";
    CoreColors["SecondaryMain"] = "#503191";
    CoreColors["ErrorMain"] = "#ce0000";
    CoreColors["ErrorLight"] = "#FBEBEB";
    CoreColors["WarningMain"] = "#f7a703";
    CoreColors["WarningDark"] = "#d18d01";
    CoreColors["WarningLight"] = "#FEF8EB";
    CoreColors["SuccessMain"] = "#00aa66";
    CoreColors["SuccessDark"] = "#149b5f";
    CoreColors["SuccessLight"] = "#E5F6F0";
    CoreColors["BackgroundGray"] = "#F8F8FC";
    CoreColors["Grey50"] = "#dfdfdf";
    CoreColors["Grey100"] = "rgba(0,0,0,0.5)";
    CoreColors["Grey200"] = "#dfdfdf";
    CoreColors["Grey300"] = "#dfdfdf";
    CoreColors["Grey400"] = "#c9c9c9";
    CoreColors["Grey500"] = "#949494";
    CoreColors["Grey600"] = "#949494";
    CoreColors["Grey700"] = "#4a4a4a";
    CoreColors["Grey800"] = "#4a4a4a";
    CoreColors["Grey900"] = "#000000";
    CoreColors["Highlight"] = "#FFFF80";
    CoreColors["White"] = "#ffffff";
    CoreColors["Orange"] = "#EB3B00";
    CoreColors["BackgroundBlue"] = "#F4FAFF";
    CoreColors["PrimaryLight"] = "#E2F4FF";
    CoreColors["PrimaryDark"] = "#002E74";
    CoreColors["Divider"] = "rgba(0,0,0,0.12)";
    CoreColors["HighContrastGreen"] = "#01884C";
})(CoreColors || (exports.CoreColors = CoreColors = {}));
// Brand specific/additional colors not native to MUI that we add in.
var AccentColors;
(function (AccentColors) {
    AccentColors["PromoGreen"] = "#C1FFCA";
    AccentColors["RichPurple"] = "#503191";
    AccentColors["RichBlue"] = "#0f69af";
    AccentColors["RichGreen"] = "#149b5f";
    AccentColors["RichRed"] = "#E61E50";
    AccentColors["SensitivePink"] = "#E1C3CD";
    AccentColors["SensitiveBlue"] = "#96D7D2";
    AccentColors["SensitiveGreen"] = "#B4DC96";
    AccentColors["SensitiveYellow"] = "#FFDCB9";
    AccentColors["VibrantMagenta"] = "#EB3C96";
    AccentColors["VibrantCyan"] = "#2DBECD";
    AccentColors["VibrantGreen"] = "#A5CD50";
    AccentColors["VibrantYellow"] = "#FFC832";
})(AccentColors || (exports.AccentColors = AccentColors = {}));
//# sourceMappingURL=colors.js.map